import { IOpenInviteModel } from '../Bookings/reducers';

export function friendsJoiningText(
  openInviteClass,
  myUserId,
  isStudioBooking,
  t,
  isInvite = false,
): string {
  if (openInviteClass && openInviteClass.openInviteUserProfiles) {
    const participantsCount = openInviteClass.openInviteUserProfiles.length;
    if (participantsCount === 2) {
      const partner = openInviteClass.openInviteUserProfiles.find(({
        uid,
      }) => uid !== myUserId);
      if (partner && isStudioBooking) {
        if (isInvite) {
          return t('acceptInviteFrom', { name: partner.nickname });
        }
        return t(partner.accepted ? 'workoutWith' : 'waitingFor', { nickname: partner.nickname });
      }
      return t('friendJoining', { count: 1 });
    }

    if (participantsCount > 2) {
      return t('friendsJoining', { count: participantsCount - 1 });
    }
  }
  return '';
}

export function getOpenInviteParticipantCount(openInviteClass?: IOpenInviteModel): number | undefined {
  if (openInviteClass?.openInviteUserProfiles) {
    return openInviteClass.openInviteUserProfiles.length;
  }
}

export function getInviterText(openInviteClass, t, inviterId) {
  if (openInviteClass && openInviteClass.openInviteUserProfiles) {
    const inviter = openInviteClass.openInviteUserProfiles.find(({
      uid,
    }) => uid === inviterId);
    if (!inviter) {
      return '';
    }
    return t('workoutWith', { nickname: inviter.nickname });
  }
  return '';
}

export function showParticipantCount(booking, openInviteClass) {
  return !!(booking.openInviteLink || booking.pairedSessionReference);
}

export function getInviterUserId(openInviteClass, myUserId): string | null {
  const inviter = openInviteClass.openInviteUserProfiles.find(({ uid }) => uid !== myUserId);
  return inviter?.uid;
}
